import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import {
  Box, Button, Columns, PageHeader,
} from '@domain-group/suit-theme'
import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import useTaskListItem from '@hooks/useTaskListItem'

import EntityActivity from '@components/EntityActivity'

import defaultRequestOptions from '@sections/Admin/packs/Projects/defaultRequestOptions'

import { generateTabBarItems } from '@sections/Admin/packs/Projects/screens/Detail/functions/generateTabBarItems'

import Assets from '../Assets'
import Checklists from '../Checklists'
import Details from '../Details'
import Links from '../Links'
import ProjectNotes from '../ProjectNotes'
import RealtimeWrapper from '../RealtimeWrapper'
import RequestedChanges from '../RequestedChanges'
import SubTasks from '../SubTasks'
import User from '../User'

interface PageContentProps {
  taskListItemId: number,
}

const PageContent = (props: PageContentProps) => {
  const { taskListItemId } = props

  // useLocation to refresh the window.location. If not used location won't reload if URL changes
  useLocation()

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const taskListItemPayload = useTaskListItem({ id: taskListItemId }, {
    performHttpRequests: !!taskListItemId,
    requestOptions: {
      ...defaultRequestOptions.image,
      ...defaultRequestOptions.user,
      include_related_entity_subject: true,
      include_task_list_item_assignee: true,
      include_task_list_item_checklist_template: true,
      include_task_list_item_related_entities: true,
      include_task_list_item_user: true,
    },
  })

  const {
    callbacks: {
      addSubTask,
    },
    taskList,
    taskListItem,
    taskListItem: { title },
    urls: { taskListItemsIndexUrl },
    user,
  } = taskListItemPayload

  return (
    <>
      {/* Ensure that the task list item has been loaded before setting up the subscription */}
      {taskListItem?.task_list_id && (
        <RealtimeWrapper taskListItem={taskListItem} />
      )}

      <Helmet>
        <title>Task Detail | Template Manager</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || taskListItemsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="tasks"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={generateTabBarItems(taskList)}
        title={title}
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <Details taskListItemPayload={taskListItemPayload} />

            {/* @ts-expect-error */}
            <EntityActivity
              componentSettings={{
                conversation: {
                  title: `Template for ${title}`,
                },
              }}
              subjectType="TaskListItem"
              subjectId={taskListItem.id}
            />
          </Columns.Main>

          <Columns.Sidebar>
            {/*
             // @ts-expect-error TS2741 */}
            <User user={user} />
            <RequestedChanges taskListItem={taskListItem} />
            <SubTasks callbacks={{ addSubTask }} taskListItem={taskListItem} />
            <Checklists taskListItem={taskListItem} />
            <Assets taskListItem={taskListItem} />
            {/* @ts-expect-error */}
            <Links taskList={taskList} taskListItem={taskListItem} />
            {/* @ts-expect-error */}
            <ProjectNotes taskList={taskList} />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
